import { render, staticRenderFns } from "./AuthRegisterWithNpiForm.vue?vue&type=template&id=478618b4&scoped=true"
import script from "./AuthRegisterWithNpiForm.vue?vue&type=script&lang=js"
export * from "./AuthRegisterWithNpiForm.vue?vue&type=script&lang=js"
import style0 from "./AuthRegisterWithNpiForm.vue?vue&type=style&index=0&id=478618b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478618b4",
  null
  
)

export default component.exports